module.exports = __webpack_public_path__ + "img/empty-sheets-dark.057d70da.svg";